import './divider.css'
const Divider = () => {
    return (
        <div className='divider'>
            <p>════ ⋆★⋆ ════</p>
        </div>
    )
}
export default Divider